<template>
  <div class="hidden">
    <div v-for="(opts, index) in modals" :key="index">
      <component :is="opts.component" :ref="'modal_' + index" v-bind="opts.props"></component>
    </div>
  </div>
</template>

<script>
  import Bus from './bus.js'

  export default {
    name: 'modalsKeep',
    created () {
      window.ModalsKeep = this
      // Create a new modal instance
      Bus.$on('new', options => {
        const defaults = {

        }
        options = Object.assign(defaults, options)

        this.modals.push(options)
        if (typeof options.cb === 'function') {
          this.$nextTick(() => {
            let index = this.modals.indexOf(options)
            let comp = null
            if (index !== -1 && this.$refs['modal_' + index]) comp = this.$refs['modal_' + index][0]
            options.cb(comp)
          })
        }
      })
    },
    data () {
      return {
        // Storage for all the modal's instances
        modals: []
      }
    },
    methods: {

    },
    computed: {
      // Get the last element of the modals array (the most recent modal instance)
      $last () {
        return this.modals.length - 1
      }
    }
  }
</script>

<style lang="stylus">

</style>